import Wishlist from "./Wishlist";
$(document).ready(function() {
  const wishlist = new Wishlist();
  prestashop.wishlist = wishlist;
  const $wishlistCount = $(".js-wishlist-count");
  $(document).on("click", ".js-wishlist-add", function(e) {
    e.preventDefault();
    var $el = $(this);
    wishlist.add($el.attr("href")).then((response) => {
      $el.removeClass("js-wishlist-add");
      $el.addClass("js-wishlist-remove");
      handleWishListCounter("up");
    });
  });
  $(document).on("click", ".js-wishlist-remove", function(e) {
    e.preventDefault();
    var $el = $(this);
    wishlist.remove($el.attr("href")).then((response) => {
      $el.removeClass("js-wishlist-remove");
      $el.addClass("js-wishlist-add");
      handleWishListCounter("down");
    });
  });
  $(document).on("click", ".js-wishlist-remove-wishlist", function(e) {
    e.preventDefault();
    $.ajax({
      method: "POST",
      dataType: "json",
      url: window.location.href,
      data: {
        ajax: 1,
        action: "removeProduct",
        id_product: $(this).data("id-product"),
        id_product_attribute: $(this).data("id-product-attribute")
      },
      success: function(response) {
        $("#js-product-list").replaceWith(response.rendered_products);
        $("#notifications").replaceWith(response.rendered_notifications);
        handleWishListCounter("down");
      }
    });
  });
  wishlist.on("afterRequest", (response) => {
    alert(response.message);
  });
  function handleWishListCounter(type = "up") {
    const currentCount = parseInt($wishlistCount.text(), 10);
    console.log(currentCount);
    if (type == "up") {
      $wishlistCount.text(currentCount + 1);
    } else if (type == "down") {
      $wishlistCount.text(currentCount - 1);
    }
  }
});
